import { Box, Stack, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { Stepper } from '../../../../../../components/Stepper';
import { Header } from '../../../../../../templates/private/components/Header';
import { useSteps } from '../../hooks';
import { StyledTypography } from '../../styles';
import { stepsUserFirstAccess } from '../../userFirstAccessSteps';

export function UserFirstAccessMobileLayout() {
  const { handleStepChange, currentStep, currentStepList } = useSteps();

  const isFirstStep = currentStep === 0;

  return (
    <>
      <Header
        theme={'light'}
        showBackButton={!isFirstStep}
        showSubHeader={false}
        showMenu={false}
        mainContent={
          <Stack gap={3} mt={'62.8px'}>
            <Stack
              gap={1}
              flexDirection="row"
              alignItems="flex-end"
              justifyContent="flex-end"
            >
              <Typography variant="text">Já tem cadastro?</Typography>
              <a href={process.env.REACT_APP_LOGIN_URL}>
                <StyledTypography
                  variant="link"
                  color={NEW_COLORS.PRIMARY[500]}
                >
                  Efetue o login
                </StyledTypography>
              </a>
            </Stack>
            <Box pt={3}>
              <Stepper
                steps={currentStepList.map(step => step.label)}
                activeStep={currentStep}
                onClickStep={handleStepChange}
              />
            </Box>
            <Stack maxWidth="md" margin="auto">
              {stepsUserFirstAccess[currentStep].step()}
            </Stack>
          </Stack>
        }
      />
    </>
  );
}
